var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    [
      _c("th", [_vm._v(_vm._s(_vm.$t(_vm.title)))]),
      _vm._v(" "),
      _c("numeric-input-table-cell", {
        attrs: {
          classes: ["input-cell"],
          disabled: _vm.isReadOnly,
          placeholderKey: "EnterValue",
          labelledBy: _vm.labelledBy + "_1"
        },
        model: {
          value: _vm.row.ages0to5,
          callback: function($$v) {
            _vm.$set(_vm.row, "ages0to5", $$v)
          },
          expression: "row.ages0to5"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-table-cell", {
        attrs: {
          classes: ["input-cell"],
          disabled: _vm.isReadOnly,
          placeholderKey: "EnterValue",
          labelledBy: _vm.labelledBy + "_2"
        },
        model: {
          value: _vm.row.ages6to17,
          callback: function($$v) {
            _vm.$set(_vm.row, "ages6to17", $$v)
          },
          expression: "row.ages6to17"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-table-cell", {
        attrs: {
          classes: ["input-cell"],
          disabled: _vm.isReadOnly,
          placeholderKey: "EnterValue",
          labelledBy: _vm.labelledBy + "_3"
        },
        model: {
          value: _vm.row.ages18to24,
          callback: function($$v) {
            _vm.$set(_vm.row, "ages18to24", $$v)
          },
          expression: "row.ages18to24"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-table-cell", {
        attrs: {
          classes: ["input-cell"],
          disabled: _vm.isReadOnly,
          placeholderKey: "EnterValue",
          labelledBy: _vm.labelledBy + "_4"
        },
        model: {
          value: _vm.row.ages25to35,
          callback: function($$v) {
            _vm.$set(_vm.row, "ages25to35", $$v)
          },
          expression: "row.ages25to35"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-table-cell", {
        attrs: {
          classes: ["input-cell"],
          disabled: _vm.isReadOnly,
          placeholderKey: "EnterValue",
          labelledBy: _vm.labelledBy + "_5"
        },
        model: {
          value: _vm.row.ages36to45,
          callback: function($$v) {
            _vm.$set(_vm.row, "ages36to45", $$v)
          },
          expression: "row.ages36to45"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-table-cell", {
        attrs: {
          classes: ["input-cell"],
          disabled: _vm.isReadOnly,
          placeholderKey: "EnterValue",
          labelledBy: _vm.labelledBy + "_6"
        },
        model: {
          value: _vm.row.ages46to55,
          callback: function($$v) {
            _vm.$set(_vm.row, "ages46to55", $$v)
          },
          expression: "row.ages46to55"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-table-cell", {
        attrs: {
          classes: ["input-cell"],
          disabled: _vm.isReadOnly,
          placeholderKey: "EnterValue",
          labelledBy: _vm.labelledBy + "_7"
        },
        model: {
          value: _vm.row.ages56to65,
          callback: function($$v) {
            _vm.$set(_vm.row, "ages56to65", $$v)
          },
          expression: "row.ages56to65"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-table-cell", {
        attrs: {
          classes: ["input-cell"],
          disabled: _vm.isReadOnly,
          placeholderKey: "EnterValue",
          labelledBy: _vm.labelledBy + "_8"
        },
        model: {
          value: _vm.row.ages66to75,
          callback: function($$v) {
            _vm.$set(_vm.row, "ages66to75", $$v)
          },
          expression: "row.ages66to75"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-table-cell", {
        attrs: {
          classes: ["input-cell"],
          disabled: _vm.isReadOnly,
          placeholderKey: "EnterValue",
          labelledBy: _vm.labelledBy + "_9"
        },
        model: {
          value: _vm.row.ages76plus,
          callback: function($$v) {
            _vm.$set(_vm.row, "ages76plus", $$v)
          },
          expression: "row.ages76plus"
        }
      }),
      _vm._v(" "),
      _c("td", { staticClass: "right disabled-background" }, [
        _c("b", [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.rowSum)))])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }